export default {
  BusinessPurchaseBasics: {
    name: 'Name',
    code: 'Code',
    value: 'Value',
    type: 'Type'
  }
};
